import { render, staticRenderFns } from "./DefineFreightValueToBe.vue?vue&type=template&id=25b63af5&scoped=true&"
import script from "./DefineFreightValueToBe.vue?vue&type=script&lang=js&"
export * from "./DefineFreightValueToBe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b63af5",
  null
  
)

export default component.exports